import permission from './ability'

const resolveRoutePermission = route => {
  if (route.meta && route.meta.permission) return route.meta.permission
  if (route.permission) return route.permission
  return null
}

export const canNavigate = to =>
  to.matched.every(route => {
    const requiredPermission = resolveRoutePermission(route)
    return permission(requiredPermission) || route.meta?.public
  })

export const _ = undefined
